export const Resources = {    
    SubscribeAriaLabel: 'Subscribe here to receive the latest Ministry News and/or Press Releases',
    BellGreetingLogged: 'Hello ',
    BellGreeting: 'Hello!',
    BellText01: 'You may be interested in subscribing to the following',
    BellText02: 'The subscription will be linked to the following email',
    BellText03: 'If you want to change it, you can do so in the user data edition',

    SubscribeTitle: 'Subscribe',
    SubscribeTitleUperCase: 'SUBSCRIBE',
    SubscribeBtnTitle: 'Subscribe to Ministry Newsletters',
    LoginSignUpUperCase: 'SIGN UP',
    SubscriptionsManagerUperCase: 'SUBSCRIPTION MANAGEMENT',
    
    Cancel: 'Cancel',
    Ok: 'Ok',

    SendActivationMailButton: 'Send activation email',
    SendActivationMailOK: 'Email sent correctly to the email address provided.',
    SendActivationMailError: 'Error while sending the message. Please try again later.',
    
    LoginAuthentication: 'Log in',
    LoginRecoverPass: 'Recover password',
    LoginSignUpText: 'If you don\'t have an account',
    LoginButton: 'Login button',
    
    ToolTipCheckBell: 'In order to unsubscribe, you need to access Subscription Management',
    EnterEmail: 'Enter your e-mail',
    EnterPass: 'Enter your password',

    RecoveryAccountModal: 'A password recovery email will be sent to the email address provided',
    RecoveryAccountModalMailSended: 'If the email address is registered you will receive an email in your inbox.',
   
    //--------- Mensajes de Error -------------
    // SecurityPasswordChange: ServiceMessage1
    // InvalidCredentials: ServiceMessage3    
    // MailInUse: ServiceMessage4
    // DocInUso: ServiceMessage5
    // SendActivationEmailError: ServiceMessage6
    // SendRecoveryEmailError: ServiceMessage7
    // InvalidToken: ServiceMessage8
    // InternalServiceError: ServiceMessage9
    // GenerateJWTNoUser: ServiceMessage10
    // NoGroupId: ServiceMessage11
    // NoAuthenticated: ServiceMessage12
    // NoActiveUser: ServiceMessage13
    // NewActivationTokenError: ServiceMessage14
    // UserNoExist: ServiceMessage16

    ServiceMessage1: 'We have improved the security system for accessing your subscriptions, so it is necessary to change your password. You can do this in the "Password recovery" section.',
    ServiceMessage2: '',
    ServiceMessage3: 'No account is associated with the given email address or the password is not correct.',
    ServiceMessage4: 'The e-mail address provided is in use.',
    ServiceMessage5: 'Identity document in use.',
    ServiceMessage6: 'User successfully created. Error while sending the user activation email.',
    ServiceMessage7: 'Error sending the user recovery email.',
    ServiceMessage8: 'The identifier is incorrect or has expired. If you are a new subscriber, you must register again.',
    ServiceMessage9: 'Internal service error.',
    ServiceMessage10: 'The user cannot be recovered.',
    ServiceMessage11: 'An error has occurred in obtaining user publications. If the problem persists, please contact technical support.',
    ServiceMessage12: 'No user actively logged in.',
    ServiceMessage13: 'The user has not yet activated the account.',
    ServiceMessage14: 'Error while generating a new activation code.',
    ServiceMessage15: '',
    ServiceMessage16: 'No account is associated with the indicated email address.',
    ServiceMessage17: 'The current password is not correct.',
    ServiceMessage19: "The new password cannot be the same as the current password.",
    ServiceMessage21: "You must complete the captcha.",

    ServiceMessage503: 'The subscription service is not available, please try again later. Sorry for the inconvenience.',
    
    ErrorCode0: 'Ok',
    ErrorCode1: 'The email field cannot be empty',
    ErrorCode2: 'The email is not correct',
    ErrorCode3: 'The password field cannot be empty',
    ErrorCode4: 'You must select at least one subscription',
    ErrorCode5: 'You must complete the captcha',
    ErrorCode6: 'The chosen password is not sufficiently secure. It must be at least 8 characters, and combine uppercase and lowercase letters, numbers, and symbols The permitted symbols are: _!@#$%^&*.-',
}